import { Component, HostListener, Inject, OnInit, DOCUMENT } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from "./components/header/header.component"
import { NgClass } from '@angular/common';
import { GtmService } from './services/gtm.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FooterComponent, HeaderComponent, NgClass],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    title = 'Shriram Wealth';
    slug: any;
    scrollToTop = false;
    removeHeight = false;

    constructor(private readonly router: Router, @Inject(DOCUMENT) private readonly doc: Document,
        private readonly gtmService: GtmService) { }

    ngOnInit() {
        if (environment.env === 'prod') {
            this.gtmService.loadGtm('GTM-NKSFKWFL');
        }
        this.removeDefaultHeight();
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.removeDefaultHeight();
            }
            if (event instanceof ActivationEnd) {
                if (typeof window !== 'undefined') {
                    window.scrollTo(0, 0);
                }
            }
        });
    }

    removeDefaultHeight() {
        let currUrl = this.router.url.split('?')[0]
            .split('#')[0]
            .split('&')[0];
        let paths = currUrl.split('/');
        this.slug = paths.at(-1);
        let pageList = [
            'not-found'
        ];
        if (pageList.includes(this.slug)) {
            this.removeHeight = true;
        } else {
            this.removeHeight = false;
        }
    }

    @HostListener('window:scroll')
    onScroll() {
        // Scroll to Top
        if (typeof window != "undefined") {
            let scroll = window.scrollY;
            if (scroll > 700) {
                this.scrollToTop = true;
            } else {
                this.scrollToTop = false;
            }
        }
    }

    // Window Scroll to Top
    handler__scrollToTop() {
        if (typeof window !== "undefined") {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }

}
